export default __webpack_public_path__ + "static/media/desktop_80.3af4dbf0.jpg";